import React from 'react'

export default t => [
	{
		Header: <span className='sort-icons'>{t('options_section.fields.name_eng')}</span>,
		accessor: 'name',
		width: 100
	}, {
		Header: t('options_section.fields.date'),
		accessor: 'date',
		Cell: ({ value }) => {
			if(!value) {
				return null
			}
			return value?.replace(/-/ig, '.')?.split('.')?.reverse()?.join('.')
		}
	}, {
		Header: t('options_section.fields.day'),
		accessor: 'day',
		Cell: ({ value }) => {
			switch (value?.toLowerCase()) {
				case 'sunday':
					return t('common.dates.sunday')
				case 'monday':
					return t('common.dates.monday')
				case 'tuesday':
					return t('common.dates.tuesday')
				case 'wednesday':
					return t('common.dates.wednesday')
				case 'thursday':
					return t('common.dates.thursday')
				case 'friday':
					return t('common.dates.friday')
				case 'saturday':
					return t('common.dates.saturday')
				default:
					return ''
			}
		},
		width: 135
	}
]
